// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('checkListItemItem', {
//         templateUrl: 'views/components/views/checkListItemItem/checkListItemItem.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'checkListItemItemService', function ($stateParams, stateService, checkListItemItemService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let checkListItemItemKeyno = $stateParams.checklistitemitem_keyno;
//             let checkListItemKeyno = $stateParams.checklistitem_keyno;
            
//             vm.model = {
//                 edit: {},
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTIONS

//             async function loadEdit() {
//                 vm.model.edit = (await checkListItemItemService.getEdit({
//                     checklistitemitem_keyno: checkListItemItemKeyno,
//                     checklistitem_keyno: checkListItemKeyno
//                 }))[0];
//             }

//             // #endregion LOAD PROCEDURE FUNCTIONS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 checkListItemItemService.saveObj(vm.model.edit).then(() => {
//                     vm.model.lockedSave = false;
//                     stateService.back();
//                 }, () => vm.model.lockedSave = false);
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadEdit();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
